import { Command } from 'pos/common';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Res, Permission } from 'core/api';
import { SmartMenuFacade } from 'pos/facades';
import { Message } from 'core/ui-next/modal';
import { Toaster } from 'core/ui-next';

declare global {
	interface CommandType {
		publicAllDigitalMenus: () => Promise<Result>
	}
}

Command.register('publicAllDigitalMenus', Preconditions.ensure(Permission.DigitalMenu_PublishAll), async (): Promise<Result> => {

	const status = await SmartMenuFacade.getPublishStatus();
	if (status.IsPublishing) {
		await Message.show(Res.Msg.MSG_PERMISSION_DENIED_FOR(Permission.toString(Permission.DigitalMenu_PublishAll)));
		return Result.error();
	}

	await SmartMenuFacade.startPublish();
	Toaster.info(Res.Msg.MSG_UPLOAD_DIGITAL_MENUS_STARTED());

	return Result.ok();

});